import { useState, useEffect } from 'react'
import { orgsAllAPI } from '../services/org-all'

function UseAllOrganization() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getOrganization = async () => {
      const body = {
        orgId: []
      }
      const resp = await orgsAllAPI(body)
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return { ...d, value: d?.id, label: d?.org }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getOrganization()
  }, [])
  return data
}

export default UseAllOrganization
